import {AfterViewInit, Component, inject, OnInit, DOCUMENT} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {I18nService} from '@shared/services/i18n.service';
import {ThemeService} from '@shared/services/theme.service';
import {INavbarMenuItem} from '@shared/interfaces/navbar';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';
import {CookieTrustService} from '@shared/services/cookie-trust.service';
import {PwaCheckForUpdateService} from '@shared/services/pwa-check-for-update.service';

@Component({
  selector: 'div[app-root]',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styles: [],
})
export class App implements OnInit, AfterViewInit {
  private cookieTrust = inject(CookieTrustService);
  private i18n = inject(I18nService);
  private theme = inject(ThemeService);
  private doc = inject(DOCUMENT);
  private pwaCheckForUpdateService = inject(PwaCheckForUpdateService);

  ngOnInit() {
    this.theme.navbarMenu.set(this.getMenuVertical());

    this.doc.documentElement.lang = this.i18n.getDefaultLang();

    this.pwaCheckForUpdateService.listenForUpdate();
  }

  ngAfterViewInit(): void {
    this.cookieTrust.run(this.i18n.getDefaultLang());
  }

  private getMenuVertical(): INavbarMenuItem[] {
    return [
      {
        label: this.i18n.translate('menu.qr_codes'),
        collapsed: false,
        children: [
          {
            text: this.i18n.translate('menu.active'),
            route: EEndpointApp.QRCODE_OVERVIEW,
            svg: 'ri.qr-code-line',
          },
          {
            text: this.i18n.translate('menu.archived'),
            route: EEndpointApp.QRCODE_ARCHIVE_REVIEW,
            svg: 'pf.archive',
          },
          /*{
            text: this.i18n.translate('menu.new_qr'),
            route: '/qr-codes/form/new',
            svg: 'pf.plus-square',
          },*/
          {
            text: this.i18n.translate('menu.analytics'),
            route: EEndpointApp.QRCODE_ANALYTICS,
            svg: 'pf.activity',
            // mark: true,
          },
          {
            text: this.i18n.translate('menu.templates'),
            route: EEndpointApp.QRCODE_TEMPLATE,
            svg: 'pf.layers',
          },
        ],
      },
      {
        label: this.i18n.translate('menu.account'),
        collapsed: false,
        children: [
          /*{
            text: this.i18n.translate('menu.profile'),
            // route: EEndpointApp.Account,
            route: '/account',
            svg: 'pf.user',
          },*/
          {
            text: this.i18n.translate('menu.teams'),
            route: EEndpointApp.ACCOUNT_TEAMS,
            // route: '/account/teams',
            svg: 'ri.team-line',
          },
          {
            text: this.i18n.translate('menu.contact_us'),
            route: EEndpointApp.CONTACT_US,
            // route: '/account/contact-us',
            svg: 'pf.message-square',
          },
          {
            text: this.i18n.translate('menu.domains'),
            route: EEndpointApp.CUSTOM_DOMAIN,
            svg: 'tr.home-ribbon',
            badge: 'new',
          },
        ],
      },
    ];
  }
}
